import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { searchThunk } from "../../redux/search/search-thunk"
import { AppDispatch } from "../../redux/store"
import "./Searchbar.scss"

const Searchbar = () => {
  const [searchValue, setSearchValue] = useState("")

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  const handleSearch = () => {
    if (searchValue.trim()) {
      dispatch(searchThunk(searchValue))
    }
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const dispatch = useDispatch<AppDispatch>()

  return (
    <div className="searchbar-container">
      <input
        type="text"
        placeholder="Search for a movie..."
        value={searchValue}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
      />
      <button onClick={handleSearch}>Search</button>
    </div>
  )
}

export default Searchbar
